import * as React from 'react';
import type { SVGProps } from 'react';
const SvgThreatsFull = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={32}
    height={32}
    fill="none"
    viewBox="0 0 32 32"
    {...props}
  >
    <path
      fill="var(--color-surface-interactive-secondary-hover)"
      d="M0 8.533A8.533 8.533 0 0 1 8.533 0h14.934A8.533 8.533 0 0 1 32 8.533v14.934A8.533 8.533 0 0 1 23.467 32H8.533A8.533 8.533 0 0 1 0 23.467z"
    />
    <path
      fill="var(--color-content-base-secondary)"
      d="M8.127 12.347v3.918c0 5.362 7.257 9.127 7.953 9.127.695 0 7.794-3.765 7.794-9.127v-5.144c0-.233-.048-.458-.137-.664l-5.52 6.057a.112.112 0 0 1-.19-.045l-.618-2.182a.112.112 0 0 0-.205-.026l-3.416 5.858 3.223-9.744a.112.112 0 0 1 .2-.026l1.487 2.271a.112.112 0 0 0 .186.002l2.484-3.679-4.71-2.004a1.68 1.68 0 0 0-1.316 0L9.15 9.575a1.68 1.68 0 0 0-1.023 1.547z"
    />
  </svg>
);
export default SvgThreatsFull;
